<div class="cim-field" [class.cim-field-fullwidth]="isFullWidth">
  <div class="cim-field-label">{{ label }}</div>
  <button
    [matMenuTriggerFor]="filtermenu"
    type="button"
    [style.min-width]="isFullWidth ? '100%' : '240px'"
    class="cim-field-control"
    [class.is-placeholder]="!selectedBenchmark"
  >
    <span class="cim-field-value">
      {{
        selectedBenchmark ? selectedBenchmark.name_full : benchmarkPlaceholder
      }}
    </span>
    @if (selectedBenchmark) {
      <button
        type="button"
        mat-icon-button
        (click)="removeBenchmark(); $event.stopPropagation()"
        class="cim-field-clear"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <span class="cim-field-arrow" aria-hidden="true"></span>
  </button>
</div>
<mat-menu #filtermenu="matMenu" [overlapTrigger]="false" class="filter-menu">
  <div mat-menu-item [disableRipple]="true" style="height: 50px">
    <mat-form-field class="w-100 bench-search-field" (click)="$event.stopPropagation()">
      <input
        placeholder="Search"
        matInput
        [(ngModel)]="searchText"
        class="select-input-search"
        (ngModelChange)="onSearchChange()"
      />
      @if (searchText != "") {
        <button
          mat-icon-button
          matSuffix
          color="primary"
          (click)="resetSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <mat-accordion class="app-nav-accordion">
    <mat-expansion-panel [hidden]="benchmarksHidden">
      <mat-expansion-panel-header (click)="$event.stopPropagation()">
        <mat-panel-title><b>Benchmarks</b></mat-panel-title>
      </mat-expansion-panel-header>

      <mat-accordion class="app-nav-accordion">
        @for (panel of benchmarks; track panel.group) {
          <mat-expansion-panel>
            <mat-expansion-panel-header
              (click)="$event.stopPropagation()"
              [hidden]="panel.hidden"
            >
              <mat-panel-title>{{ panel.group }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              @for (f of panel.items | search: searchText; track f.name) {
                <div
                  mat-menu-item
                  [hidden]="f.hidden == true"
                  (click)="onBenchmarkSelect(f)"
                  [class.active]="
                    selectedBenchmark && f.name === selectedBenchmark.name
                  "
                >
                  {{ f.name_full }}
                </div>
              }
            </mat-nav-list>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-expansion-panel>

    <!--    <mat-expansion-panel [hidden]="portfoliosHidden">
    <mat-expansion-panel-header (click)="$event.stopPropagation()">
      <mat-panel-title><b>Portfolios</b></mat-panel-title>
    </mat-expansion-panel-header>
    <mat-nav-list>
      <div mat-menu-item
        *ngFor="let f of portfolios | search: searchText"
        [hidden]="f.hidden == true"
        (click)="onBenchmarkSelect(f)"
        [class.active]="f.name === this.selectedBenchmark"
      >{{f.name}}</div>
    </mat-nav-list>
  </mat-expansion-panel> -->
  </mat-accordion>
</mat-menu>
